import React, { useState, useEffect, useRef } from 'react';
import { Page, NotifyModal } from 'components';
import { Form } from './components';
import Header from '../../components/Header/Header';
import Reload from 'components/Reload/Reload';
import ApiMServer from 'services/ApiMServer';

import './ServerLocalDetail.css';

const ServerLocalDetail = (props) => {
  const { serial } = props.match.params;
  const [serials] = useState(serial);

  const user = JSON.parse(localStorage.getItem('userData'));
  if (user?.permission?.cooperatives?.read !== true) {
    window.location.replace('/home');
  }

  const [permission, setPermission] = useState(false);
  const [server, setServer] = useState('');
  const [type, setType] = useState({ "color": "", "status": "" });
  const [modalShow, setModalShow] = useState(false);
  const [unit, setUnit] = useState([]);
  const [loading, setLoading] = useState(true);

  // Estado para detecção de tema
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    const bodyHasDarkClass = document.body.classList.contains('dark-theme');
    const htmlHasDarkClass = document.documentElement.classList.contains('dark-theme');

    if (savedTheme) {
      return savedTheme;
    }

    return bodyHasDarkClass || htmlHasDarkClass ? 'dark' : 'light';
  });

  // useRef para evitar chamadas desnecessárias
  const hasInitialized = useRef(false);

  const handleAlertModalSuccess = (msg) => {
    setType({ "color": "#198754", "status": msg });
    setModalShow(true);
  };

  const handleAlertModalError = (msg) => {
    setType({ "color": "red", "status": msg });
    setModalShow(true);
  };

  // useEffect para detectar mudanças de tema
  useEffect(() => {
    const handleThemeChange = () => {
      const bodyHasDarkClass = document.body.classList.contains('dark-theme');
      const htmlHasDarkClass = document.documentElement.classList.contains('dark-theme');
      const savedTheme = localStorage.getItem('theme');

      let detectedTheme = 'light';

      if (savedTheme) {
        detectedTheme = savedTheme;
      } else if (bodyHasDarkClass || htmlHasDarkClass) {
        detectedTheme = 'dark';
      }

      setTheme(detectedTheme);
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          handleThemeChange();
        }
      });
    });

    observer.observe(document.body, { attributes: true });
    observer.observe(document.documentElement, { attributes: true });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const initializeComponent = async () => {
      if (hasInitialized.current) return;

      setLoading(true);
      try {
        const { permission } = JSON.parse(localStorage.getItem('userData'));
        setPermission(permission?.equipments?.write);

        // Buscar dados do servidor e empresas em paralelo
        const [serverResponse] = await Promise.all([
          ApiMServer.get(`/api/v1/server-config/${serials}`),
          handleGetCompany()
        ]);

        setServer(serverResponse.data);
        hasInitialized.current = true;

      } catch (err) {
        console.error("Erro ao inicializar componente:", err);
        handleAlertModalError("Erro ao carregar dados do servidor");
      } finally {
        setLoading(false);
      }
    };

    initializeComponent();
  }, [serials]);

  const handleGetCompany = async () => {
    try {
      const { data } = await ApiMServer.get(`/company/get`);
      const companies = data
        .filter(company => company.name && company._id)
        .map(company => ({
          _id: company._id,
          name: company.name
        }));

      setUnit(companies);
    } catch (error) {
      console.error("Erro ao buscar empresas:", error);
      setUnit([]);
    }
  };


  const handleFieldChange = (event, field, value) => {
    event.persist && event.persist();
    setServer((values) => ({
      ...values,
      [field]: value
    }));
  };

  const handleSubmit = async () => {
    if (!server || typeof server !== 'object') {
      handleAlertModalError("Dados do servidor inválidos");
      return;
    }

    setLoading(true);
    try {
      const { data } = await ApiMServer.put(`/api/v1/server-config/${serials}`, server);
      setServer(data);
      handleAlertModalSuccess("Servidor atualizado com sucesso!");
    } catch (err) {
      console.error("Erro ao atualizar servidor:", err);
      const errorMessage = err.response?.data?.message || "Erro ao atualizar o servidor. Verifique os dados e tente novamente.";
      handleAlertModalError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Page className="p-3 server-local-detail" title="Server Local">
      <Header page="Server Local" />

      {loading && <Reload />}

      <NotifyModal
        type={type}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <Form
        unit={unit}
        server={server}
        permission={permission}
        fieldChange={handleFieldChange}
        onSubmit={handleSubmit}
        loading={loading}
        theme={theme}
      />

    </Page>
  );
};

export default ServerLocalDetail;
